import React from "react";
import { Stack } from "react-bootstrap";
import { Link } from "react-router-dom";

import { Breakpoint } from "../../hooks/useBreakpoint";
import { isXOrSmaller } from "../../lib/utils";

const SiteManagementSidebar = ({
    breakpoint,
    toggleNavbar,
}: {
    breakpoint: Breakpoint;
    toggleNavbar: () => void;
}): React.JSX.Element => {
    const routePrefix = "/site-management";

    return (
        <Stack gap={2}>
            <Link
                to={`${routePrefix}/settings/date`}
                className="btn btn-primary"
                onClick={toggleNavbar}
            >
                Date Settings
            </Link>
            <Link
                to={`${routePrefix}/settings/display`}
                className="btn btn-primary"
                onClick={toggleNavbar}
            >
                Display Settings
            </Link>
            <Link
                to={`${routePrefix}/content`}
                className="btn btn-primary"
                onClick={toggleNavbar}
            >
                Page Content
            </Link>
            <Link
                to={`${routePrefix}/content/resume`}
                className="btn btn-primary"
                onClick={toggleNavbar}
            >
                Resume
            </Link>
            <Link
                to={`${routePrefix}/content/waiver`}
                className="btn btn-primary"
                onClick={toggleNavbar}
            >
                Waiver Text
            </Link>
            <Link
                to={`${routePrefix}/umpirepay`}
                className="btn btn-primary"
                onClick={toggleNavbar}
            >
                Umpire Pay
            </Link>
            <Link
                to={`${routePrefix}/photoApproval`}
                className="btn btn-primary"
                onClick={toggleNavbar}
            >
                Photo Approvals
            </Link>
            <Link
                to={`${routePrefix}/rules/majorybl`}
                className="btn btn-primary"
                onClick={toggleNavbar}
            >
                MajorYBL Rules
            </Link>
            <Link
                to={`${routePrefix}/rules/majorhighschool`}
                className="btn btn-primary"
                onClick={toggleNavbar}
            >
                Major High School Rules
            </Link>
            <Link
                to={`${routePrefix}/content/policy-and-procedures`}
                className="btn btn-primary"
                onClick={toggleNavbar}
            >
                Policy & Procedures
            </Link>
            <Link
                to={`${routePrefix}/content/terms-and-conditions`}
                className="btn btn-primary"
                onClick={toggleNavbar}
            >
                Terms and Conditions
            </Link>
            <Link
                to={`${routePrefix}/advertisers`}
                className="btn btn-primary"
                onClick={toggleNavbar}
            >
                Advertisers
            </Link>
            <Link
                to={`${routePrefix}/payment-reminders`}
                className="btn btn-primary"
                onClick={toggleNavbar}
            >
                Payment Reminders
            </Link>
        </Stack>
    );
};

export default SiteManagementSidebar;
